const adminDivisions = {
  NZ_REGIONS: [
    { name: 'Northland', value: 'Northland' },
    { name: 'Auckland', value: 'Auckland' },
    { name: 'Waikato', value: 'Waikato' },
    { name: 'Bay of Plenty', value: 'Bay of Plenty' },
    { name: 'Gisborne', value: 'Gisborne' },
    { name: 'Hawkes Bay', value: 'Hawkes Bay' },
    { name: 'Taranaki', value: 'Taranaki' },
    { name: 'Manawatu-Whanganui', value: 'Manawatu-Whanganui' },
    { name: 'Wellington', value: 'Wellington' },
    { name: 'Tasman', value: 'Tasman' },
    { name: 'Nelson', value: 'Nelson' },
    { name: 'Marlborough', value: 'Marlborough' },
    { name: 'West Coast', value: 'West Coast' },
    { name: 'Canterbury', value: 'Canterbury' },
    { name: 'Otago', value: 'Otago' },
    { name: 'Southland', value: 'Southland' },
  ],

  AU_STATES: [
    { name: 'New South Wales', value: 'NSW' },
    { name: 'Victoria', value: 'VIC' },
    { name: 'Queensland', value: 'QLD' },
    { name: 'Western Australia', value: 'WA' },
    { name: 'South Australia', value: 'SA' },
    { name: 'Tasmania', value: 'TAS' },
    { name: 'Australian Capital Territory', value: 'ACT' },
    { name: 'Northern Territory', value: 'NT' },
  ],

  US_STATES: [
    { name: 'Alabama', value: 'AL' },
    { name: 'Alaska', value: 'AK' },
    { name: 'Arizona', value: 'AZ' },
    { name: 'Arkansas', value: 'AR' },
    { name: 'California', value: 'CA' },
    { name: 'Colorado', value: 'CO' },
    { name: 'Connecticut', value: 'CT' },
    { name: 'Delaware', value: 'DE' },
    { name: 'Florida', value: 'FL' },
    { name: 'Georgia', value: 'GA' },
    { name: 'Hawaii', value: 'HI' },
    { name: 'Idaho', value: 'ID' },
    { name: 'Illinois', value: 'IL' },
    { name: 'Indiana', value: 'IN' },
    { name: 'Iowa', value: 'IA' },
    { name: 'Kansas', value: 'KS' },
    { name: 'Kentucky', value: 'KY' },
    { name: 'Louisiana', value: 'LA' },
    { name: 'Maine', value: 'ME' },
    { name: 'Maryland', value: 'MD' },
    { name: 'Massachusetts', value: 'MA' },
    { name: 'Michigan', value: 'MI' },
    { name: 'Minnesota', value: 'MN' },
    { name: 'Mississippi', value: 'MS' },
    { name: 'Missouri', value: 'MO' },
    { name: 'Montana', value: 'MT' },
    { name: 'Nebraska', value: 'NE' },
    { name: 'Nevada', value: 'NV' },
    { name: 'New Hampshire', value: 'NH' },
    { name: 'New Jersey', value: 'NJ' },
    { name: 'New Mexico', value: 'NM' },
    { name: 'New York', value: 'NY' },
    { name: 'North Carolina', value: 'NC' },
    { name: 'North Dakota', value: 'ND' },
    { name: 'Ohio', value: 'OH' },
    { name: 'Oklahoma', value: 'OK' },
    { name: 'Oregon', value: 'OR' },
    { name: 'Pennsylvania', value: 'PA' },
    { name: 'Rhode Island', value: 'RI' },
    { name: 'South Carolina', value: 'SC' },
    { name: 'South Dakota', value: 'SD' },
    { name: 'Tennessee', value: 'TN' },
    { name: 'Texas', value: 'TX' },
    { name: 'Utah', value: 'UT' },
    { name: 'Vermont', value: 'VT' },
    { name: 'Virginia', value: 'VA' },
    { name: 'Washington', value: 'WA' },
    { name: 'Washington DC', value: 'DC' },
    { name: 'West Virginia', value: 'WV' },
    { name: 'Wisconsin', value: 'WI' },
    { name: 'Wyoming', value: 'WY' },
  ],
};

export default adminDivisions;

export const { NZ_REGIONS, AU_STATES, US_STATES } = adminDivisions;
